import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import { useInfiniteQuery } from 'react-query';
import { Plugins, PluginsResponse } from 'types/Plugins';
import {
  generateFilter,
  generatePaginationQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { fetchWrapper } from 'utils/fetchWrapper';

const getSparks = (pageParam: number) => {
  const queryArray = [
    // 1 should always be public type
    generateFilter('pluginPrivacyTypeID', 1),
    generatePaginationQuery({
      pageNumber: pageParam,
      pageSize: 10,
    }),
  ];
  const url = generateURL(SPARK_RESOURCE_TYPES.PLUGINS, queryArray);
  return fetchWrapper<PluginsResponse>({
    url: url,
    method: 'GET',
  });
};

export const useInfinitePluginQuery = (enabled: boolean = true) => {
  const queryResult = useInfiniteQuery(
    ['plugins paginated'],
    ({ pageParam = 1 }) => getSparks(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return lastPage?.data?.length ? allPages?.length + 1 : undefined;
      },
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`failed to Fetch Sparks: ${error.message}`);
        }
      },
      enabled,
      ...CACHE_AND_STALE_TIME,
    }
  );
  const { data: pluginsResponse, ...restQueryResult } = queryResult;
  const plugins = pluginsResponse?.pages.reduce<Plugins[]>((acc, page) => {
    if (!page?.data) {
      return acc;
    }
    return [...acc, ...(page.data || [])];
  }, []);

  return {
    plugins,
    ...restQueryResult,
  };
};
